import menuApi from '../../api/menu'

// initial state
const state = {
  messages: [
    "Any message you like can go here",
    "Will rotate through list of actual messages"
  ],
  hasMail: false,
  hasTasksDue: false,
}

// getters
const getters = {
}

// actions
const actions = {
  getInitialData ({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      menuApi.getInitialData(initialData => {
        commit('setMessages', initialData.messages)
        commit('setHasMail', initialData.hasMail)
        commit('setHasTasksDue', initialData.hasTasksDue)
        resolve()
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },
}

// mutations
const mutations = {
  setMessages (state, messages) {
    state.messages = messages
  },
  setHasMail (state, hasMail) {
    state.hasMail = hasMail
  },
  setHasTasksDue (state, hasTasksDue) {
    state.hasTasksDue = hasTasksDue
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
